import { EnrollApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';
import { getQueryKeys } from 'queries/query-key';

function useSelectAdditional() {
  const queryClient = useQueryClient();
  return useAuthMutation(EnrollApi.selectAdditional, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useSelectAdditional;
